import { url } from '../../../api/endpointURL';
import React, { useState } from 'react';

// error notification box
import './edit-modal.css';

// Import generic components
import Button from '../../../generic_components/Button/Button';
import Select from '../../../generic_components/Select/Select';
import { useToast } from '../../../generic_components/Toast/Toast';

const moment = require('moment-timezone');


const EditTzModal = ( {hwid, closeModal, site, setTableData, tableData} ) => {
    const [selectedTz, setSelectedTz] = useState('');
    const[loading, setLoading] = useState(false);

    const timeZones = moment.tz.names();

    const toast = useToast();
        
    const handleUpdateTz = async() => {
        try {
        const data = {hwid, selectedTz}
        const response = await fetch(`${url}/edit-tz`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify(data),
        });

        const result = await response.json();

        if (result.code === 200) {          
            const successMsg = `timezone updated to ${selectedTz} successfully.`;
            toast.success(successMsg, {
                hideProgressBar: true,
                autoClose: 9000 
            });       
            // update setTableData with the new SI name
            const updatedTableData = tableData.map((item) => {
                if (item.hwid === hwid) {
                    return { ...item, local_timezone: selectedTz };
                }
                return item;
            });
            setTableData(updatedTableData);                    
        }
        // add delay of 1 second before closing the modal
        await new Promise(resolve => setTimeout(resolve, 1000));   
        setLoading(false);    
        closeModal();
      
        } catch(error) {
            setLoading(false);
            setSelectedTz('');
            console.log(`Error in updating timezone : ${error}`);
            const errorMsg = `Interal server error, please try again later.`;
            toast.error(errorMsg, {
                hideProgressBar: true,
                autoClose: 9000    
            });
        }
    }

    const handleSelectChange = (e) => {
        setSelectedTz(e.target.value); 
    }

    // let timezone_options = [{label: "Select a timezone", value: ""}];
    // timezone_options = [...timezone_options, ...timeZones.map((tz, index) => (
    // {
    //     label: tz,
    //     value: tz
    // }
    // ))];

    // const timezone_options = [{label: "Select a timezone", value: ""}, ...timeZones.map((tz, index) => (
    // {
    //     label: tz,
    //     value: tz
    // }
    // ))];

    const timezone_options = timeZones.map((tz, index) => (
    {
        label: tz,
        value: tz
    }
    ));

  return (
    <div>        
        <div className='modal-sites-body-title'>
            Select local timezone for the site {site}:
        </div>

        <Select
            placeholder="Select a timezone"
            value={selectedTz}
            onChange={handleSelectChange}
            className='modal-sites-body-select'
            options={timezone_options}
        >
        </Select>
      
        <Button 
            size='small'
            className='modal-sites-body-btn-submit'
            onClick={() => handleUpdateTz()}
            disabled={loading}  /* Disable when loading */
            >
            Update
        </Button>

       <div className='modal-sites-body-btn-loading-container'>
            { loading && (
                    <div className='loading-spinner'>
                        <div className="spinner-border modal-sites-body-loading-icon" role="status">
                            <span className="visually-hidden">Loading...</span>
                        </div>
                    </div>
                )
            }
        </div>  
        
    </div>
    

  )
}

export default EditTzModal